import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";
import {
  BACK_ROW,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  VALUE_FILL,
  hideColumnsAfter,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  setupPrinciple2DetailSheet,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import { safeText, toYesNo } from "./principle6SheetHelpers.js";
import { formatExcelDate } from "./principle8SheetHelpers.js";

export const SHEET_NAME = "Details of SIA";

const SHEET_TITLE =
  "Details of Social Impact Assessments (SIA) of projects undertaken by the entity based on applicable laws, in the current financial year.";

const WIDTHS = {
  A: 3.453125,
  B: 3.453125,
  C: 9.1796875,
  D: 6.26953125,
  E: 32.54296875,
  F: 32.54296875,
  G: 21.54296875,
  H: 30.7265625,
  I: 22.1796875,
  J: 32.54296875,
  K: 9.1796875,
  L: 9.1796875,
};

const TEMPLATE_ROW = 10;
const SPACER_ROW = 11;
const DATA_START_ROW = 12;
const COL_END = COL_J;
const ALL_THIN = Array(7).fill("tttt");

export function buildDetailsOfSIASheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd: COL_END,
    ySplit: 11,
    topLeftCell: "D12",
    zoomScale: 70,
    hiddenCols: ["A", "B"],
  });
  hideColumnsAfter(ws, 12);
  // setupPrinciple2DetailSheet hardcodes zoom 80; match ref zoom
  ws.views[0].zoomScale = 70;
  ws.views[0].zoomScaleNormal = 70;

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  addSheetTitle(ws, COL_END, SHEET_TITLE, {
    height: 30,
    borderPatterns: ALL_THIN,
  });

  applyBorderPattern(ws, HEADER_ROW, COL_D, ALL_THIN);
  ws.getRow(HEADER_ROW).height = 29;
  [
    { col: COL_D, label: "Sr. No." },
    { col: COL_E, label: "Name and brief details of project" },
    { col: COL_F, label: "SIA Notification No." },
    { col: COL_G, label: "Date of notification" },
    { col: COL_H, label: "Whether conducted by independent external agency" },
    { col: COL_I, label: "Results communicated in public domain" },
    { col: COL_J, label: "Relevant Web link" },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: false,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, ALL_THIN);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).height = 11.25;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, COL_END, { row: SPACER_ROW, height: 30, patterns: ALL_THIN });

  const rows = sectionC?.principle8?.essentialIndicators?.socialImpactAssessments || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        { col: COL_D, value: idx + 1, align: "center", fill: null, font: BODY_FONT },
        {
          col: COL_E,
          value: safeText(item?.projectName, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_F,
          value: safeText(item?.SIANotificationNo, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_G,
          value: formatExcelDate(item?.dateOfNotification),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_H,
          value: toYesNo(item?.conductedByExternalAgency),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_I,
          value: toYesNo(item?.resultsCommunicatedPublicDomain),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_J,
          value: safeText(item?.webLink, ""),
          align: "left",
          fill: VALUE_FILL,
        },
      ],
      { patterns: ALL_THIN }
    );
  });

  return ws;
}
